import { render, staticRenderFns } from "./fwaltop.vue?vue&type=template&id=2a3fb5be&scoped=true&"
import script from "./fwaltop.vue?vue&type=script&lang=js&"
export * from "./fwaltop.vue?vue&type=script&lang=js&"
import style0 from "./fwaltop.vue?vue&type=style&index=0&id=2a3fb5be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3fb5be",
  null
  
)

export default component.exports